import { combineReducers } from "redux";
import regReducer from "./EligibilityApis/eligibility.reducer";
import aptReducer from "./Appointment/apt.reducer";
/** rootReducer
 * @fileOverview Combine  all reducer action
 * @author  Akhil Francis <akhil@trillium-technologies.com>
 */

const rootReducer = combineReducers({
  eligibility: regReducer,
  Appointment: aptReducer
});

export default rootReducer;
